import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { BOOKING_URL, HERO_BADGES, IMAGES } from "../data/content";

export const Hero = () => (
  <section
    id="home"
    data-testid="hero-section"
    className="relative min-h-[90vh] flex flex-col items-center justify-center text-center px-4 sm:px-8 overflow-hidden"
  >
    <img
      src={IMAGES.hero}
      alt="Luxury spa ambience"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-black/70" />
    <div className="relative z-10 max-w-5xl mx-auto flex flex-col items-center gap-8 py-24">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-amber-400 text-xs sm:text-sm font-bold uppercase tracking-[0.3em]"
      >
        Gurugram • Sikanderpur • DLF Phase 1
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        data-testid="hero-headline"
        className="font-serif text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-white leading-tight"
      >
        G69 Spa —{" "}
        <span className="bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 bg-clip-text text-transparent">
          Men's Steam Bath
        </span>{" "}
        &amp; Spa Gurgaon
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2 }}
        data-testid="hero-subtitle"
        className="text-white/80 text-base md:text-lg font-light max-w-2xl"
      >
        Experience ancient bathing rituals, deep massage therapies, steam &amp;
        jacuzzi in the heart of Gurgaon.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.3 }}
        className="flex flex-wrap gap-3 justify-center"
      >
        {HERO_BADGES.map((b) => (
          <span
            key={b}
            data-testid={`hero-badge-${b.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="flex items-center gap-2 border border-amber-400/50 bg-white/5 backdrop-blur-md text-white/90 text-xs sm:text-sm px-4 py-2 rounded-full"
          >
            <BadgeCheck className="w-4 h-4 text-emerald-400" />
            {b}
          </span>
        ))}
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.4 }}
        className="flex flex-col sm:flex-row gap-4 mt-2"
      >
        <a
          href="#services"
          data-testid="hero-explore-rituals-btn"
          className="bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 text-black px-8 py-4 rounded-full text-sm font-bold uppercase tracking-[0.2em] hover:shadow-[0_0_25px_rgba(245,158,11,0.5)] transition-shadow duration-300"
        >
          Explore Rituals
        </a>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="hero-book-doorstep-btn"
          className="border border-amber-400/50 text-amber-300 px-8 py-4 rounded-full text-sm font-bold uppercase tracking-[0.2em] hover:bg-amber-400/10 hover:border-amber-400 transition-colors duration-300"
        >
          Book Doorstep Session
        </a>
      </motion.div>
    </div>
  </section>
);
